$(document).ready(function () {
  // Initializing filters
  let brandIdFilter = null
  let typedFilter = null

  // Helper Functions --------------------------------------------------------------------------------------------------
  const filterBrands = (brandIdFilter, typedFilter) => {
    // Each note/brand bubble under the bubbles container
    const noteViews = $('#playbook .note-view-js');
    const sectionNotes = $('#playbook .clients-playbooks-playbook-component .section__notes');

    // Un-hide any previously filtered bubbles and section notes
    noteViews.removeClass('d-none')
    sectionNotes.removeClass('d-none')
    if (!brandIdFilter && !typedFilter) {
      sectionNotes.addClass('d-none')
      return // All bubbles should show with no filters, but section notes should be hidden
    }

    noteViews.each(index => {
      const noteView = $(noteViews[index]);
      let hide = false;

      if (brandIdFilter) {
        const brandId = noteView.attr('brand_id');
        if (brandId !== brandIdFilter) {
          hide = true;
        }
      }

      if (typedFilter) {
        const brandTitle = noteView.attr('brand_name')?.toLowerCase();
        const noteText = noteView.find('.note-paragraph')?.text().toLowerCase();
        const brandTitleCheck = !brandTitle?.includes(typedFilter.toLowerCase());
        const noteTextCheck = !noteText?.includes(typedFilter.toLowerCase());

        if (brandTitleCheck && noteTextCheck) {
          hide = true;
        }
      }

      if (hide) {
        noteView.addClass('d-none');
      } else { // If not hiding bubble, and the carat is down, then toggle the carat
        const arrows = noteView.closest('.section__notes').closest('.section').find('.arrows')
        if (arrows.find('arrows__up').hasClass('d-none')) {
          caretToggle(arrows) // Pass in 'arrows'
        }
      }
    });
  }


  const addNote = (brandId, contactId, note, noteFrom, section, noPrepend = false, sectionNotes) => {
    $.post('/components/clients/playbooks/playbook/client_notes', { // brandId CAN be empty
      brand_id: brandId,
      hs_contact_id: contactId,
      note: note,
      section: section,
      note_from: noteFrom
    }).done(function (html) {
      if (!sectionNotes) return
      const noteForm = sectionNotes.closest('.section').find('.section__add-note-input .note-form-js');

      if (noPrepend) return
      sectionNotes.prepend(html) // Prepend note to section notes
      if (sectionNotes.hasClass('d-none')) { // Un-hide section notes, Toggle arrow
        sectionNotes.removeClass('d-none')
        caretToggle(sectionNotes.closest('.section').find('.arrows'))
      }
      // Find the note form, reset it, and hide it
      noteForm.find('textarea').val('')
      noteForm.find('select').val('')
      noteForm.find('.select-note-from-js').val('advisor') // Reset note_from to 'advisor'
      noteForm.addClass('d-none')
    }).fail(function (response) {
      const data = response.responseJSON;
      if (data) {
        if (!data['success']) alert('There was an issue saving your Note, if the issue persists, let us know.');
      }
    });
  }


  const updateNote = (noteId, brandId, note, noteFrom, section, noReplace, noteForm) => { // ContactId was required on creating a note, and shouldn't be changed, so it's omitted here
    $.post(`/components/clients/playbooks/playbook/client_notes/${noteId}`, {
      brand_id: brandId,
      note: note,
      note_from: noteFrom,
      section: section
    }).done(function (html) {
      if (noReplace) return

      // The update action returns the note_view partial only, so just replace the class .note-view-js
      noteForm.closest('.note-bubble-container-js').find('.note-view-js').replaceWith(html)
      noteForm.addClass('d-none');
      // The note edit field gets replaced by the finished note
    }).fail(function (response) {
      const data = response.responseJSON;
      if (data) {
        if (!data['success']) alert('There was an issue saving your Note, if the issue persists, let us know.');
      }
    });
  }


  function caretToggle(currentThis, expand = null) {
    const arrowUp = currentThis.find('.arrows__up')
    const arrowDown = currentThis.find('.arrows__down')
    const sectionNotes = currentThis.closest('.section').find('.section__notes')

    const shouldOpen = expand === null ? arrowUp.hasClass('d-none') : expand

    if (shouldOpen) {
      arrowUp.removeClass('d-none')
      arrowDown.addClass('d-none')
      sectionNotes.removeClass('d-none')
    } else {
      arrowDown.removeClass('d-none')
      arrowUp.addClass('d-none')
      sectionNotes.addClass('d-none')
    }
  }

  // End Helper Functions ----------------------------------------------------------------------------------------------


  // Event Listeners For Filters ---------------------------------------------------------------------------------------
  // When listening for the filter fields, need to send BOTH filters everytime to persist old filter bubbles
  $(document).on('change', '#playbook #select-brand-filter', function (e) {
    brandIdFilter = e.target.value
    filterBrands(brandIdFilter, typedFilter)
  });
  $(document).on('input', '#playbook #text-brand-filter', function (e) {
    typedFilter = e.target.value
    filterBrands(brandIdFilter, typedFilter)
  });
  // End Event Listeners For Filters -----------------------------------------------------------------------------------


  // Event Listeners For Updating / Creating / Deleting Notes --------------------------------------------------------------------------------
  // CHECK BUTTON ON NOTE FORM
  $(document).on('click', '.clients-playbooks-playbook-component .note-form-js .check-btn-js', function () {
    const noteForm = $(this).closest('.note-form-js');
    const textarea = noteForm.find('.new-note-field');
    const sectionNotes = noteForm.closest('.section').find('.section__notes');

    const note = textarea.val()
    const hsContactId = textarea.attr('hs_contact_id')
    const section = noteForm.find('.select-note-type-js').val()
    const noteFrom = noteForm.find('.select-note-from-js').val()
    const noteId = textarea.attr('note_id')
    const brandId = noteForm.find('.select-brand-note-js').val()

    if (!note) return // Don't save if the note is empty
    if (noteId) {
      updateNote(noteId, brandId, note, noteFrom, section,false, noteForm)
    } else {
      addNote(brandId, hsContactId, note, noteFrom, section, false, sectionNotes)
    }
  });


  // TRASH CAN ICON ON NOTE VIEW
  $(document).on('click', '.clients-playbooks-playbook-component .note-view-js .delete-note-js', function () {
    if (!confirm('You are about to delete a note. Are you sure?')) return

    const noteView = $(this).closest('.note-view-js')
    const id = noteView.attr('id')

    $.ajax({
      url: `/components/clients/playbooks/playbook/client_notes/${id}`,
      method: 'delete'
    }).done(function (data) {
      if (data['success']) noteView.closest('.note-bubble-container-js').remove();
    }).fail(function (response) {
      alert(`There was an issue removing this data. Let us know if this issue persists.`)
    });
  });


  // PENCIL ICON ON NOTE VIEW
  $(document).on('click', '.clients-playbooks-playbook-component .note-view-js .edit-note-js', function () {
    const sectionParent = $(this).closest('.note-bubble-container-js')
    const noteView = $(this).closest('.note-view-js')
    const noteForm = sectionParent.find('.note-form-js')

    noteForm.removeClass('d-none');
    noteView.addClass('d-none');
    // Trigger autoresize in class
    const textareaAutoHeights = noteForm.find('.textarea-auto-height');
    textareaAutoHeights.trigger('input');
  });


  // X BUTTON ON NOTE FORM
  $(document).on('click', '#playbook .component .note-form-js .x-btn-js', function () {
    const sectionParent = $(this).closest('.note-bubble-container-js')
    const noteForm = $(this).closest('.note-form-js')
    const noteView = sectionParent.find('.note-view-js')

    noteForm.addClass('d-none');
    noteView.removeClass('d-none');
  });
  // End Event Listeners For Updating Notes ----------------------------------------------------------------------------


  // Event Listener For AutoSaving Client Why
  let timeoutId = null;
  // -----------------------------------------------------------------------------------------------
  $(document).on('input', '.clients-playbooks-playbook-component .client-why textarea', function () {
    const textarea = $(this);
    const textareaVal = textarea.val();
    const hsContactId = textarea.attr('hs_contact_id');
    const section = textarea.attr('section');
    const noteId = textarea.attr('note_id');
    const saveText = textarea.closest('.client-why').find('.client-why__autosave');
    const noteFrom = 'advisor'

    // If timeout is already going, clear it and start again
    if (timeoutId !== null) clearTimeout(timeoutId)

    saveText.removeClass('d-none').text('Saving...');

    timeoutId = setTimeout(() => {

      if (noteId) {
        updateNote(noteId, null, textareaVal, noteFrom, section,true)
      } else {
        addNote(null, hsContactId, textareaVal, noteFrom, section, true)
      }

      saveText.text('Saved!');

      // Remove the "Saved" message after 5 seconds
      setTimeout(() => {
        saveText.addClass('d-none');
      }, 5000);
    }, 1000); // Delay of 500ms after user stops typing

  });
// End Event Listener For AutoSaving Client Why
// ---------------------------------------------------------------------------------------------


  // Showing A Tab As Active -------------------------------------------------------------------------------------------
  $('#playbook .playbook-component-tabs__tab').on('click', function () {
    if ($(this).hasClass('active')) return
    else {
      $(this).closest('.playbook-component-tabs').find('.playbook-component-tabs__tab').removeClass('active');
      $(this).addClass('active');
    }
  })
  // End Showing A Tab As Active ---------------------------------------------------------------------------------------

  // Event Listeners For Carat Toggle ---------------------------------------------------------------------------
  $(document).on('click', '.clients-playbooks-playbook-component .section__tab', function (event) {
    const section = $(this).closest('.section');
    const addButton = $(this).find('.add-note-button');

    // Don't toggle if the add note button is clicked
    if (addButton.is(event.target)) return;

    caretToggle(section);
  })
  // End Event Listener for Carat Toggle---------------------------------------------------------------------------

  // Event Listener for Adding / Removing Note Form ---------------------------------------------------------------------------
  $(document).on('click', '.clients-playbooks-playbook-component .add-note-button', function (e) {
    const addNoteInputBox = $(this).closest('.section').find('.section__add-note-input');

    // Show note input box
    addNoteInputBox.find('.note-form-js').removeClass('d-none');
    // Open section if it's not already open
    caretToggle(addNoteInputBox.closest('.section'), true);
  })
  // End Event Listener for Adding / Removing Note Form ---------------------------------------------------------------------------

  // Event Listeners For Showing/Hiding Text ---------------------------------------------------------------------------
  // Toggling between full and truncated note/brand bubble content
  $(document).on('click', '.note-bubble .show-more-text', function () {
    const noteContentParent = $(this).closest('.note-text')

    $(this).closest('.small-paragraph').addClass('d-none')
    $(this).addClass('d-none')
    noteContentParent.find('.large-paragraph').removeClass('d-none')
    noteContentParent.find('.show-less-text').removeClass('d-none')
  });
  $(document).on('click', '.note-bubble .show-less-text', function () {
    const noteContentParent = $(this).closest('.note-text')

    noteContentParent.find('.large-paragraph').addClass('d-none')
    $(this).addClass('d-none')
    noteContentParent.find('.small-paragraph').removeClass('d-none')
    noteContentParent.find('.show-more-text').removeClass('d-none')
  });
  // End Event Listeners For Showing/Hiding Text -----------------------------------------------------------------------

  // Event Listeners For Expand / Collapse All ---------------------------------------------------------------------------
  $(document).on('click', '#playbook .expand-collapse-all', function () {
    const sectionNotes = $(this).closest('#playbook').find('.clients-playbooks-playbook-component .section__notes')
    const arrows = $(this).closest('#playbook').find('.clients-playbooks-playbook-component .arrows')

    if (sectionNotes.hasClass('d-none')) {
      sectionNotes.removeClass('d-none')
      caretToggle(arrows)
      $(this).text('Collapse All')
    } else {
      sectionNotes.addClass('d-none')
      caretToggle(arrows)
      $(this).text('Expand All')
    }
  })
  // End Event Listener for Expand / Collapse All ---------------------------------------------------------------------------

  // Event Listeners For Toggle Active Brands ---------------------------------------------------------------------------
  $(document).on('click', '#playbook .playbook-activity .toggle-brands .toggle__pill', function () {
    const hsContactId = $(this).closest('.toggle-brands').attr('hs_contact_id')
    const active_tab = $('#playbook .playbook-component-tabs .playbook-component-tabs__tab.active').attr('name')
    const currentActive = $(this).closest('.toggle').attr('active') === 'true'
    const newActive = !currentActive

    // Call playbook show page and replace content
    window.location = `/playbooks/${hsContactId}?only_active_brands=${newActive}&active_tab=${active_tab}`
  })
  // End Event Listener for Toggle Active Brands ---------------------------------------------------------------------------
});
